import { getInvoiceStatus } from "../../utils/getInvoiceStatus";
import type { IInvoice } from "../../../create/interfaces/invoice.interfaces";

/**
 * An invoice is "blocking" (prevents creating a new one for the same scope) when it is
 * UNPAID or PAID. REFUNDED/CANCELLED invoices free the scope to issue a new invoice.
 */
export const isBlockingInvoice = (invoice: IInvoice): boolean => {
  const s = getInvoiceStatus(invoice);
  return s === "UNPAID" || s === "PAID";
};

/** True when none of the invoices in the list is in a blocking state. */
export const canIssueNewInvoice = (invoices: IInvoice[]): boolean => !invoices.some(isBlockingInvoice);
